import React from 'react'
import { isEmpty } from 'lodash'
import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  withPromotionListItemForm,
  PromotionListItemForm,
} from './PromotionListItemForm'
import PromotionListLayout from './PromotionListLayout'

class AddPromotionListItemForm extends React.Component {
  handleAutoSyncOnBlur = e => {
    this.handleSavePromotion()
  }

  handleAutoSyncOnChange = e => {
    this.handleSavePromotion()
  }

  handleAutoSync = (name, value) => {
    this.handleSavePromotion()
  }

  handleSavePromotion = () => {
    if (isEmpty(this.props.errors) && this.props.onSavePromotion) {
      this.props.onSavePromotion(this.props.values)
    }
  }

  componentDidMount() {
    this.props.validateForm()
  }

  render() {
    return (
      <PromotionListLayout>
        <PromotionListItemForm
          {...this.props}
          handleAutoSync={this.handleAutoSync}
          handleAutoSyncOnBlur={this.handleAutoSyncOnBlur}
          handleAutoSyncOnChange={this.handleAutoSyncOnChange}
        />
      </PromotionListLayout>
    )
  }
}

export default compose(
  connect(({ info: { language } }) => ({ language })),
  withPromotionListItemForm,
)(AddPromotionListItemForm)



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/AddPromotionListItemForm.js